import React from "react";
import Footer from "../../components/Footer";
import Head from "../../components/Head";

const Private: React.FC = (props) => {  
  return (    
    <div className="page-main" >
      <Head/>
      <div style={{ overflow:"auto"}}>{props.children}</div>
      <Footer />
    </div>
  );
};

export default Private;
